import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";

const CardStatistiqueItem = ({ title, icon, className, url, counterStart, counterEnd, counterDuration, stats = []}) => {
  
  return (
    <Col md={4}>
      <Link to={url} className="text-decoration-none">
        <Card className="card-animate" style={{borderRadius:'15px'}}>
          <CardBody className="d-flex flex-column h-100">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <div className=" mb-0" style={{ color: '#252525', fontFamily: 'Raleway', fontSize: '17px', fontWeight: 'bold', }}>{title} 
                <span className="counter-value" style={{marginLeft:'5px'}}>
                 (<CountUp
                    start={counterStart}
                    end={counterEnd}
                    duration={counterDuration}
                  />)
                </span>
                </div>
                
              </div>
              
              <div>
                <div className="avatar-sm flex-shrink-0">
        
                    <FeatherIcon icon={icon} className={className}/>
            
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center flex-grow-1">
              <h2 className="text-center mt-4 ff-secondary fw-semibold" style={{ color: '#252525', fontFamily: 'Raleway', fontSize: '17px', fontWeight: 'bold'}}>
                <span className="counter-value">
                  <CountUp
                    start={counterStart}
                    end={counterEnd}
                    duration={counterDuration}
                  />
                </span>
              </h2>
            </div>

            <Row className="mt-4">
              {stats.map((stat, index) => (
                <Col key={index} className={stat.align || "text-left"}>
                  <div>
                  <div className="text-center  "style={{ color: '#303030', fontFamily: 'Inter', fontSize: '28px', fontWeight: 'bold' }}>{stat.value}</div>
                    <div className="text-center mb-2 fw-semibold fs-12 "style={{ color: '#A6A6A6', fontFamily: 'Inter', fontSize: '14px', fontWeight: '500px', marginTop: '10px' }}>{stat.label}</div>
                 
                  </div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Link>
    </Col>
  );
};

export default CardStatistiqueItem;
